export const shopingChartMedicine = {
  path: "/shoping-chart-medicine",
  name: "shopingChartMedicine",
  hidden: true,
  component: () => import("@/components/buyMedicine/components/shopingChart"),
  meta: {
    title: "Keranjang",
    icon: "fa-capsules",
    roles: ["administrator", "member"]
  }
};
export default shopingChartMedicine;



// WEBPACK FOOTER //
// ./src/router/modules/shoping-chart.js